'use strict';

var Range = require('./internal/Range'),
    defineOnPrototype = require('../common/internal/defineOnPrototype');

defineOnPrototype(Range, {

  'contains': function(obj) {
    if (obj == null) return false;
    if (obj.start && obj.end) {
      return obj.start >= this.start && obj.start <= this.end &&
             obj.end   >= this.start && obj.end   <= this.end;
    } else {
      return obj >= this.start && obj <= this.end;
    }
  }

});

// This package does not export anything as it is
// simply defining "contains" on Range.prototype.


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/range/contains.js
// module id = 389
// module chunks = 0